import { trackEvent } from '@patrianna/analytics'
import { openDialog } from '@patrianna/dialog-manager'
import { nextTick } from '@patrianna/shared-utils'

import BannerTile from 'components/BannerTile'
import { useAppSelector } from 'src/store/hooks'
import { ImagesDirectory, generateImageUrl } from 'src/utils/setImageUrl'
import { sweepstakeEnabledSelector } from 'store/modules/appConfig/selectors'
import { getSentWelcomeEmailFieldSelector } from 'store/modules/user/selectors'

function WelcomeEmailBanner() {
  const sweepstakeEnabled = useAppSelector(sweepstakeEnabledSelector)
  const isSentEmail = useAppSelector(getSentWelcomeEmailFieldSelector)
  const bannerUrl = generateImageUrl('banners/check-mail-without-bg/source.png', ImagesDirectory.BANNERS)

  const openWelcomeEmailDialog = () => {
    nextTick().then(() => {
      trackEvent('clicked_on_banner', { category: 'welcome-email-banner' })
      trackEvent('welcome_banner_click')
      openDialog({ dialogName: 'WELCOME_EMAIL_SEND_DIALOG' })
    })
  }

  if (!sweepstakeEnabled || isSentEmail) {
    return null
  }

  return (
    <BannerTile onClick={openWelcomeEmailDialog} src={bannerUrl} alt='invite friends' dataTest='welcome-email-banner' />
  )
}

export default WelcomeEmailBanner
